export const US_RETURN_OPTIONS = [
  {
    value: 0,
    label: 'UPS Drop-off',
    description: [
      'Drop off at any UPS location near you.',
      'Print the return shipping label in the next step.'
    ]
  },
  {
    value: 1,
    label: 'UPS Pick-up',
    description: [
      'Schedule a free pick-up with UPS.',
      'Print the return shipping label in the next step.'
    ]
  }
];

export const INTERNATIONAL_RETURN_OPTIONS = [
  {
    value: 2,
    label: 'DHL Drop-off/Pick-up',
    description: [
      'Drop off at any DHL location near you.',
      'Print the return shipping label in the next step or schedule a pick-up with DHL.'
    ]
  }
];
